/**
 * Session publique de recherche d'adresses (décision de Karim du 28/09/2026 au
 * soir, contrat §18.33) : UN jeton Cloudflare Turnstile invisible, vérifié une
 * fois par le serveur et échangé contre une session de 30 minutes, partagée
 * par TOUS les champs d'adresse de l'onglet (six participants compris). Jamais
 * un jeton par frappe.
 *
 * Active seulement si l'interrupteur `NUXT_PUBLIC_ADRESSES_PUBLIQUES` est
 * allumé ET qu'une sitekey existe (`NUXT_PUBLIC_CF_TURNSTILE_SITEKEY`) ; sinon
 * le champ reste en BAN directe, comme avant. Côté navigateur seulement : le
 * script Turnstile n'est chargé qu'au PREMIER FOCUS d'un champ d'adresse
 * (rien pour un visiteur qui ne tape pas d'adresse, rien sur le LCP).
 */
import {
  ACTION_TURNSTILE_ADRESSES,
  creerSessionAdressesPubliques,
  obtenirJetonTurnstile,
  type SessionAdressesPubliques,
} from "@donoor/utils";
import { adressesPubliquesApi } from "~/services/api/addressLookup";

/** Une session par onglet (module) : tous les champs la partagent. */
let sessionOnglet: SessionAdressesPubliques | null = null;

export function useSessionAdressesPubliques() {
  const config = useRuntimeConfig();
  const apiBase = String(config.public.apiBaseUrl || "");
  const sitekey = String(config.public.cfTurnstileSitekey || "");
  // Booléen au build ; lu depuis l'environnement au démarrage, Nuxt le rend
  // en nombre ou en chaîne (« 1 ») : les trois formes valent « allumé ».
  const interrupteur: unknown = config.public.adressesPubliques;
  const allume = interrupteur === true || interrupteur === 1 || interrupteur === "1" || interrupteur === "true";
  const active = allume && sitekey !== "" && apiBase !== "";

  /** La session de l'onglet, créée à la demande ; null si la route protégée est éteinte. */
  function session(): SessionAdressesPubliques | null {
    if (!active || !import.meta.client) return null;
    sessionOnglet ??= creerSessionAdressesPubliques({
      obtenirTurnstile: () => obtenirJetonTurnstile({ sitekey, action: ACTION_TURNSTILE_ADRESSES }),
      ouvrir: (turnstile) => adressesPubliquesApi.ouvrirSession(apiBase, turnstile),
    });
    return sessionOnglet;
  }

  return { active, apiBase, session };
}
